var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.299 33.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.nlasfldsjflwen{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H33.3V33.3H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "nlasfldsjflwen",
    d: "M12.55,23.424a2.775,2.775,0,1,1-2.775-2.775A2.783,2.783,0,0,1,12.55,23.424Zm-2.775-11.1A2.775,2.775,0,1,0,12.55,15.1,2.783,2.783,0,0,0,9.775,12.325ZM9.775,4A2.775,2.775,0,1,0,12.55,6.775,2.783,2.783,0,0,0,9.775,4ZM18.1,9.55a2.775,2.775,0,1,0-2.775-2.775A2.783,2.783,0,0,0,18.1,9.55Zm0,2.775A2.775,2.775,0,1,0,20.875,15.1,2.783,2.783,0,0,0,18.1,12.325Zm0,8.325a2.775,2.775,0,1,0,2.775,2.775A2.783,2.783,0,0,0,18.1,20.649Z",
    transform: "translate(2.712 1.55)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.5c4a22fc.svg";
export { ForwardRef as ReactComponent };